export const formatPartnerDate = (value?: string | null) => {
  if (!value) return '—'
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  const date = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export const formatPartnerUnits = (value?: number | null) => {
  if (value === undefined || value === null) return '—'
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export const formatPartnerMoney = (amount?: number | null, currencyCode?: string | null) => {
  const units = formatPartnerUnits(amount)
  if (units === '—') return units
  return currencyCode ? `${currencyCode} ${units}` : units
}

export const formatPartnerCents = (cents?: number | null) => {
  if (cents === undefined || cents === null) return '—'
  return formatPartnerUnits(cents / 100)
}

export const formatPartnerAmount = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '') return '—'
  if (typeof value === 'number') return formatPartnerUnits(value)
  return value
}

export const formatPartnerQuantity = (value?: number | null) => {
  if (value === undefined || value === null) return '—'
  return value.toLocaleString('en-US', { maximumFractionDigits: 4 })
}

export const formatPartnerStatus = (value?: string | null) => {
  if (!value?.trim()) return '—'
  return value
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export const partnerStatusClass = (value?: string | null) => {
  const key = (value || '').toLowerCase()
  if (/(approv|active|complete|paid|success|executed)/.test(key)) return 'partner-status--positive'
  if (/(reject|fail|expir|cancel)/.test(key)) return 'partner-status--negative'
  if (/(pending|review|progress|submit)/.test(key)) return 'partner-status--pending'
  return 'partner-status--neutral'
}
